import { useSelector } from "react-redux";

const ChallengeItems = () => {
    const { challengeItems } = useSelector((state) => state.challenge);
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th scope="col" className="text-center fs-7">Name</th>
                    <th scope="col" className="text-center fs-7">Description</th>
                    <th scope="col" className="text-center fs-7">Image</th>
                </tr>
            </thead>
            <tbody>
                {
                    challengeItems && challengeItems.length ? challengeItems.map((items, i) => (
                        <tr key={`challenge-items-${i}`}>
                            <td className="text-center fs-7">{items?.itemname || null}</td>
                            <td className="text-justify fs-7">
                                {items?.description
                                    ? `${items.description.substring(0, 100)}${items.description.length > 100 ? "..." : ""}`
                                    : "-"}
                            </td>
                            <td className="text-center fs-7" style={{ width: "30%" }}>
                                {items?.imageurl ?
                                    <img src={items?.imageurl || null} alt={`item-${i}`} style={{ width: "100%" }} /> :
                                    "NA"
                                }
                            </td>
                        </tr>
                    )) : <tr>
                        <td colSpan={3} className="text-center">No Challenge Found</td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default ChallengeItems;